import AceEditor from 'react-ace-builds';
import 'views/components/searchbar/queryinput/webpack-resolver';
import 'views/components/searchbar/queryinput/ace-queryinput';
import 'ace-builds/src-min-noconflict/ext-language_tools';

export default AceEditor;
